import {Point, FeatureCollection, Geometry} from "geojson"
import {Feature} from "ol"
import {GeoJSON} from "ol/format"
import {Geometry as OLGeometry} from "ol/geom"
import {TFullNavObject} from "@ui/api/features"
import popupService from "./PopupService"
import FeatureService, {TPropDesc} from "./FeatureService"
import {LayerId} from "./"

export interface IOtherService {
  addFeatures<T extends TFullNavObject>(others: FeatureCollection<Geometry, T>, layerId: LayerId): void
  toggleLayer(isVisible: boolean): void
}

export class OtherService extends FeatureService implements IOtherService {
  otherLayers = [LayerId.ACHBRT, LayerId.WRECKS, LayerId.OBSTRN, LayerId.DISMAR]

  private constructOtherPopup(feature: Feature<OLGeometry>, layerId: LayerId) {
    const featureProps = feature.getProperties()
    let popupPropNames: (string | TPropDesc)[] = []
    switch (layerId) {
      case LayerId.OBSTRN:
        popupPropNames = [
          "obstruction_category",
          {name: "water_level", isDictionary: true},
          {name: "sounding_exposition", isDictionary: true},
          {name: "surface_nature", isDictionary: true},
          {name: "sounding_value", isData: true}
        ]
        break
      case LayerId.ACHBRT:
        popupPropNames = [{name: "anchorage_category", isDictionary: true}]
        break
      case LayerId.WRECKS:
        popupPropNames = ["wreck_category", {name: "water_level", isDictionary: true}, {name: "is_noticeable", isDictionary: true}]
        break
      case LayerId.DISMAR:
        popupPropNames = ["distance_mark_category"]
        break
    }
    return FeatureService.constructFeaturePopup([
      {
        name: layerId,
        obj: featureProps,
        propNames: [
          ...popupPropNames,
          {name: "obj_name", hasNational: true, isDictionary: true},
          {name: "information", hasNational: true, isDictionary: true}
        ]
      }
    ])
  }

  addFeatures<T extends TFullNavObject>(others: FeatureCollection<Point, T>, layerId: LayerId): void {
    const formatter = new GeoJSON()
    let features = formatter.readFeatures(others) as Feature<OLGeometry>[]
    if (features.length > 0) {
      features = features.map(feature => {
        if (feature.getProperties().icon_name) {
          feature.set("onClick", () => {
            popupService.showPopup(
              feature,
              this.constructOtherPopup(feature, layerId),
              () => feature.setProperties({selected: false})
            )
            feature.setProperties({selected: true})
          })
        }
        return feature
      })
      FeatureService.addFeatures(layerId, features)
    }
  }

  toggleLayer(isVisible: boolean) {
    this.otherLayers.forEach(layerId => FeatureService.getLayer(layerId)?.setVisible(isVisible))
  }
}

export default new OtherService() as IOtherService
